import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    itemName: String,
    itemId: String,
  };

  initialize() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "promoter_create_event_complete",
      item_name: this.itemNameValue || undefined,
      item_id: this.itemIdValue || undefined,
    });
  }
}
